import { useState, useRef, useCallback, useEffect } from 'react';

/**
 * Hook personalizado para rastrear o tempo de preenchimento do formulário
 * Usado para análise comportamental anti-bot
 */
export const useFillTimer = () => {
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [fillTime, setFillTime] = useState(0);
  const startTimeRef = useRef(null);
  const intervalRef = useRef(null);

  // Inicia o timer quando o usuário aceita os termos
  const startTimer = useCallback(() => {
    if (!isTimerActive) {
      startTimeRef.current = Date.now();
      setIsTimerActive(true);
      
      // Atualiza o tempo a cada segundo para debug (opcional)
      intervalRef.current = setInterval(() => {
        if (startTimeRef.current) {
          const currentTime = Date.now() - startTimeRef.current;
          setFillTime(currentTime);
        }
      }, 1000);
      
      console.log('⏱️ Timer de preenchimento iniciado');
    }
  }, [isTimerActive]);

  // Para o timer e retorna o tempo total
  const stopTimer = useCallback(() => {
    if (isTimerActive && startTimeRef.current) {
      const totalTime = Date.now() - startTimeRef.current;
      setFillTime(totalTime);
      setIsTimerActive(false);
      
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      
      console.log(`⏱️ Timer parado. Tempo total: ${totalTime}ms (${(totalTime / 1000).toFixed(1)}s)`);
      return totalTime;
    }
    return 0;
  }, [isTimerActive]);

  // Reseta o timer
  const resetTimer = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    
    startTimeRef.current = null;
    setIsTimerActive(false);
    setFillTime(0);
    
    console.log('⏱️ Timer resetado');
  }, []);

  // Obtém o tempo atual sem parar o timer
  const getCurrentTime = useCallback(() => {
    if (isTimerActive && startTimeRef.current) {
      return Date.now() - startTimeRef.current;
    }
    return fillTime;
  }, [isTimerActive, fillTime]);

  // Formata o tempo para exibição (opcional)
  const formatTime = useCallback((timeMs) => {
    const seconds = Math.floor(timeMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    
    if (minutes > 0) {
      return `${minutes}m ${remainingSeconds}s`;
    }
    return `${remainingSeconds}s`;
  }, []);

  // Cleanup no unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return {
    isTimerActive,
    fillTime,
    startTimer,
    stopTimer,
    resetTimer,
    getCurrentTime,
    formatTime
  };
};
